import { createTheme } from "@mui/material";
import { AppTheme } from "../context/MainContextProvider";
const lightTypography = {
  fontFamily: "Oswald, Montserrat",
  htmlFontSize: 16,
  fontSize: 14,
  h1: {
    fontStyle: "normal",
    fontWeight: "700",
    color: "#4A4A4A",
    lineHeight: "120%",
    fontSize: "3.25rem",
    fontFeatureSettings: '"pnum" on, "lnum" on',
    "@media (min-width:600px)": {
      fontSize: "3.75rem",
    },
    "@media (min-width:900px)": {
      fontSize: "4rem",
    },
  },
  h2: {
    fontStyle: "normal",
    fontWeight: "600",
    color: "#383737",
    fontSize: "3rem",
    lineHeight: "125%",
    "@media (min-width:600px)": {
      fontSize: "3.25rem",
    },
    "@media (min-width:900px)": {
      fontSize: "3.5rem",
    },
  },
  h3: {
    fontStyle: "normal",
    fontWeight: "700",
    color: "#4A4A4A",
    fontSize: "2.5rem",
    lineHeight: "125%",
    fontFeatureSettings: '"pnum" on, "lnum" on',
    "@media (min-width:600px)": {
      fontSize: "2.75rem",
    },
    "@media (min-width:900px)": {
      fontSize: "3rem",
    },
  },
  h4: {
    fontWeight: 500,
    fontSize: "2rem",
    letterSpacing: "-0.06px",
    lineHeight: "24px",
    color: "#383737",
  },
  h5: {
    fontWeight: 500,
    fontSize: "1.5rem",
    letterSpacing: "-0.05px",
    lineHeight: "20px",
    fontFeatureSettings: '"pnum" on, "lnum" on',
    color: "#383737",
  },
  h6: {
    fontWeight: 500,
    fontSize: "1.385rem",
    letterSpacing: "-0.05px",
    lineHeight: "20px",
    fontFeatureSettings: '"pnum" on, "lnum" on',
    color: "#4A4A4A",
  },
  body1: {
    color: "#4A4A4A",
    fontFeatureSettings: '"pnum" on, "lnum" on',
  },
};
const darkTypography = {
  fontFamily: "Oswald, Montserrat",
  fontWeight: 400,
  htmlFontSize: 16,
  fontSize: 14,
  h1: {
    fontStyle: "normal",
    fontWeight: "700",

    lineHeight: "120%",
    fontSize: "3.25rem",
    fontFeatureSettings: '"pnum" on, "lnum" on',
    "@media (min-width:600px)": {
      fontSize: "3.75rem",
    },
    "@media (min-width:900px)": {
      fontSize: "4rem",
    },
  },
  h2: {
    fontStyle: "normal",
    fontWeight: "600",

    fontSize: "3rem",
    lineHeight: "125%",
    "@media (min-width:600px)": {
      fontSize: "3.25rem",
    },
    "@media (min-width:900px)": {
      fontSize: "3.5rem",
    },
  },
  h3: {
    fontStyle: "normal",
    fontWeight: "700",

    fontSize: "2.5rem",
    lineHeight: "125%",
    fontFeatureSettings: '"pnum" on, "lnum" on',
    "@media (min-width:600px)": {
      fontSize: "2.75rem",
    },
    "@media (min-width:900px)": {
      fontSize: "3rem",
    },
  },
  h4: {
    fontWeight: 500,
    fontSize: "2rem",
    letterSpacing: "-0.06px",
    lineHeight: "24px",
  },
  h5: {
    fontWeight: 500,
    fontSize: "1.5rem",
    letterSpacing: "-0.05px",
    lineHeight: "20px",
    fontFeatureSettings: '"pnum" on, "lnum" on',
  },
  h6: {
    fontWeight: 500,
    fontSize: "1.385rem",
    letterSpacing: "-0.05px",
    lineHeight: "20px",
    fontFeatureSettings: '"pnum" on, "lnum" on',
  },
  body1: {
    fontFeatureSettings: '"pnum" on, "lnum" on',
  },
};
const darkMuiTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#FF9F0C",
    },
    secondary: {
      main: "#a8b6bc",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
  typography: darkTypography,
});
const lightMuiTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#E68A00",
    },
    secondary: {
      main: "#2F4858",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        selectLabel: {
          marginBottom: "0",
        },
        displayedRows: {
          marginBottom: "0",
        },
      },
    },
  },
  typography: lightTypography,
});
const ropMuiTheme = createTheme({
  palette: {
    mode: "dark",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
  typography: darkTypography,
});
export const ropTheme: AppTheme = {
  name: "rop",
  muiTheme: ropMuiTheme,
  backgroundColor: "#060807",
  cardsDefaultBgColor: "#1E1E1E",
  headerMenuBgColor: "#b35201",
  headerMenuBgImage: "linear-gradient(to left, #b35201, #B2B1AF)",
};
export const darkTheme: AppTheme = {
  name: "dark",
  muiTheme: darkMuiTheme,
  backgroundScreenColor: "#0B001D",
  headerMenuBgColor: "#1E1E1E",
  cardsDefaultBgColor: "#1E1E1E",
  cardArrowsColor: "#C8CCCF",
  cardBorderColor: "#C8CCCF",
    cardBoxBackgroudColor: "rgba(217, 217, 217, 0.03)",
    asideMenuBackgroundColor: "transparent",
};
export const lightTheme: AppTheme = {
  name: "light",
  muiTheme: lightMuiTheme,
  iconsColor: "#737373",
  backgroundColor: "#FBFCFD",
  backgroundScreenColor: "rgba(26,1,68,0.15",
  cardsDefaultBgColor: "#FFFFFF",
  primaryTextColor: "#4A4A4A",
  secondaryTextColor: "#666666",
  headerMenuBgColor: "#FFFFFF",
  cardArrowsColor: "#3B3B3C",
  cardBorderColor: "#3B3B3C",
    cardBoxBackgroudColor: "rgba(217, 217, 217, 0.03)",
    asideMenuBackgroundColor: "transparent",
};
export const darkThemeTwo: AppTheme = {
  name: "dark",
  muiTheme: darkMuiTheme,
  backgroundScreenColor: "#252423",
  headerMenuBgColor: "#1E1E1E",
  cardsDefaultBgColor: "#1E1E1E",
  cardArrowsColor: "#C8CCCF",
  cardBorderColor: "#C8CCCF",
    cardBoxBackgroudColor: "#323130",
    asideMenuBackgroundColor: "#161616",
};
export const lightThemeTwo: AppTheme = {
  name: "light",
  muiTheme: lightMuiTheme,
  iconsColor: "#424242",
  backgroundColor: "#FBFCFD",
  backgroundScreenColor: "#F4F4F4",
  cardsDefaultBgColor: "#FFFFFF",
  primaryTextColor: "#424242",
  secondaryTextColor: "#666666",
  headerMenuBgColor: "#FFFFFF",
  cardArrowsColor: "#3B3B3C",
  cardBorderColor: "#3B3B3C",
  cardBoxBackgroudColor: "#FFFFFF",
  asideMenuBackgroundColor: "#161616",
};